import React from 'react'
import Hero from '../components/Homepage/Hero'
import HomeAbout from '../components/Homepage/HomeAbout'
import DetailHero from '../components/Homepage/DetailHero'
import Location from '../components/Homepage/Location'
import Footer from '../components/Homepage/Footer'

const Homepage = () => {
    return (
        <div>
        <Hero/>
        <HomeAbout/>
        <DetailHero/>
        <Location/>
        <Footer/>

        </div>
    )
}

export default Homepage